import { Button, styled } from "@mui/material";

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
  height: 44,
}));

export default StyledButton;
